<template>
  <div>
    <van-nav-bar :title="lang.propertyPlat" left-arrow :right-text="lang.chucun" @click-right="savePlat('warp')" @click-left="prev" />
    <div class="has-image-bg" v-if="unitImage.length > 0 || floUrl.length > 0">
      <div class="unit-image" v-if="unitImage.length > 0">
        <img :src="unitImage.length > 0 && unitImage[0].imagePath + '?x-oss-process=style/720x540_c'" alt="" @click="lookBigPic($event)" />
        <div class="tips">樓層平面圖</div>
        <div class="check-box">
          <van-checkbox v-model="checked1" shape="square" checked-color="#ee0a24"></van-checkbox>
        </div>
      </div>
      <div class="flo-image" v-if="floUrl.length > 0">
        <img :src="floUrl.length > 0 && floUrl[0].imagePath + '?x-oss-process=style/720x540_c'" alt="" @click="lookBigPic($event)" />
        <div class="tips">單位平面圖</div>
        <div class="check-box">
          <van-checkbox v-model="checked2" shape="square" checked-color="#ee0a24"></van-checkbox>
        </div>
      </div>
    </div>
    <div v-if="unitImage.length == 0 && floUrl.length == 0">
      <div class="not-img">
        <img src="@/assets/wutu.png" alt="" />
        <span>{{ lang.sorry }}</span>
      </div>
    </div>
    <van-image-preview v-model="showViewer" @onClose="closeViewer" :images="srcList"></van-image-preview>
  </div>
</template>

<script>
import lang from './../../../common/language/post';
import pub from './../../../common/public.js';
import { Dialog, Toast } from 'vant';
export default {
  data() {
    return {
      lang,
      unitImage: [],
      floUrl: [],
      checked1: true,
      checked2: true,
      showViewer: false,
      srcList: [],
      platimg: [],
    };
  },
  created() {
    if (this.store.state.platimg && this.store.state.platimg.length > 0) {
      if (this.store.state.platimg.length == 1 && this.store.state.platimg[0].imageType == 101) {
        this.unitImage = this.store.state.platimg[0];
        this.floUrl = [];
        this.checked1 = true;
        this.checked2 = false;
      }
      if (this.store.state.platimg.length == 1 && this.store.state.platimg[0].imageType == 100) {
        this.unitImage = [];
        this.floUrl = this.store.state.platimg[0];
        this.checked1 = false;
        this.checked2 = true;
      }
      if (this.store.state.platimg.length > 1) {
        this.checked1 = true;
        this.checked2 = true;
        this.store.state.platimg.forEach((item) => {
        if (item && item.imageType == 101) {
          this.unitImage = item;
        } else if (item && item.imageType == 100) {
          this.floUrl = item;
        }
      });
      }
    } else {
      this.checked1 = false;
      this.checked2 = false;
    }
    this.selPlaImg();
  },
  mounted() {},
  methods: {
    closeViewer() {
      this.showViewer = false;
    },
    lookBigPic(e) {
      this.srcList = [];
      if (event.target.nodeName === 'IMG') {
        this.srcList.push(event.target.src);
        this.showViewer = true;
      }
    },
    // 保存数据
    savePlat() {
      if (this.checked1 && this.unitImage.length > 0) {
        this.platimg.push(this.unitImage[0]);
      } else {
        this.platimg.forEach((item, index) => {
          if (item.imageType == 101) {
            this.platimg.splice(index, 1)
          }
        })
      }
      if (this.checked2 && this.floUrl.length > 0) {
        this.platimg.push(this.floUrl[0]);
      } else {
        this.platimg.forEach((item, index) => {
          if (item.imageType == 100) {
            this.platimg.splice(index, 1)
          }
        })
      }
      // 利用vuex保存数据
      this.store.commit('setplatimg', { platimg: this.platimg });
      this.$router.go(-1);
    },
    prev() {
      window.stop();
      this.$router.go(-1);
    },
    // 获取平面图数据
    selPlaImg() {
      this.unitImage = this.store.state.unitImage;
      this.floUrl = this.store.state.floUrl;
    },
  },
};
</script>

<style scoped lang="scss">
.has-image-bg {
  background: #000;
  height: calc(100vh - 63px);
  padding: 0 16px;
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
}
.unit-image {
  position: relative;
  width: 164px;
  height: 164px;
  border-radius: 4px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.flo-image {
  position: relative;
  width: 164px;
  height: 164px;
  border-radius: 4px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.tips {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 164px;
  height: 32px;
  opacity: 0.5;
  background: #000000;
  border-radius: 0 0 4px 4px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 11px;
  color: #ffffff;
  line-height: 32px;
}
.check-box {
  position: absolute;
  top: 12px;
  right: 12px;
}
.not-img {
  // width: 285px;
  position: absolute;
  top: 0;
  bottom: 366px;
  left: 0;
  right: 0;
  height: 30%;
  margin: auto;
  span {
    display: block;
    // width: 285px;
    height: 21px;
    font-size: 15px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #333333;
    line-height: 21px;
  }

  img {
    border: 1px dashed #969798;
  }
}
/deep/.van-nav-bar__text {
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #f73343;
  line-height: 20px;
  letter-spacing: 0;
}
/deep/.van-nav-bar__title {
  font-family: PingFangSC-Medium;
  font-weight: bold;
  font-size: 17px;
  color: #333333;
  letter-spacing: 0.2px;
  text-align: center;
}
/deep/.van-checkbox__icon .van-icon {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #979797;
  border-radius: 4px;
  line-height: 16px;
}
</style>
